import ClientPortalLegalForms from './ClientPortalLegalForms';

export default ClientPortalLegalForms;
